import UrlTypes from '@/enums/UrlTypes';
import type IUrl from '@/interfaces/IUrl';

/** Re-orders pending URLs so Category / Hub come first. */
export const buildOrderedQueue = (pending: IUrl[]): IUrl[] => [
    ...pending.filter(
        (u) =>
            u.urlType === UrlTypes.CATEGORY ||
            u.urlType === UrlTypes.CATEGORY_HUB,
    ),
    ...pending.filter(
        (u) =>
            u.urlType !== UrlTypes.CATEGORY &&
            u.urlType !== UrlTypes.CATEGORY_HUB,
    ),
];
